module.exports = __webpack_public_path__ + "img/srp-build-img.fc03bebc.jpg";